export default __webpack_public_path__ + "static/media/christmasLogo.69fdc4f4.svg";